import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Container, Paper, Typography, Box, useTheme, Button } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';

const Login = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { isAuthenticated } = useSelector((state) => state.auth);
  
  // 如果已认证，重定向到工作台页面
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/workspace');
    }
  }, [isAuthenticated, navigate]);

  // 处理返回首页
  const handleGoToLanding = () => {
    navigate('/landing');
  };

  return (
    <Box
      className="gradient-bg"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: { xs: 2, sm: 4 }
      }}
    >
      <Container maxWidth="sm">
        <Box 
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            mb: 4
          }}
        >
          <Typography 
            component="h1" 
            variant="h3" 
            className="gradient-heading"
            sx={{ mb: 2, fontWeight: 700 }}
          >
            TransLite
          </Typography>
          <Typography 
            component="h2" 
            variant="subtitle1" 
            sx={{ mb: 2, color: theme.palette.text.secondary, maxWidth: '500px' }}
          >
            简单、高效、直接，专为签证翻译而生
          </Typography>
        </Box>
        <Paper 
          elevation={3}
          sx={{
            p: { xs: 3, sm: 4 },
            width: '100%',
            borderRadius: 3,
            backgroundColor: 'white',
            boxShadow: theme.shadows[3],
            transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
            '&:hover': {
              transform: 'translateY(-5px)',
              boxShadow: theme.shadows[4],
            }
          }}
        >
          <Typography 
            component="h3" 
            variant="h5" 
            sx={{ mb: 3, textAlign: 'center', fontWeight: 600 }}
          >
            登录功能已迁移
          </Typography>
          
          <Box sx={{ textAlign: 'center', py: 2 }}>
            <Typography 
              variant="body1" 
              sx={{ mb: 3, color: theme.palette.text.secondary, lineHeight: 1.6 }}
            >
              为了提供更好的用户体验，登录功能已集成到首页。
              <br />
              请前往首页使用便捷的登录功能。
            </Typography>
            
            <Button
              variant="contained"
              size="large"
              startIcon={<HomeIcon />}
              onClick={handleGoToLanding}
              sx={{
                py: 1.5,
                px: 4,
                fontSize: '1rem',
                borderRadius: theme.shape.borderRadius * 1.5,
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: '0 4px 12px rgba(67, 83, 255, 0.3)',
                '&:hover': {
                  boxShadow: '0 6px 16px rgba(67, 83, 255, 0.4)',
                  transform: 'translateY(-2px)',
                },
                transition: 'all 0.2s ease'
              }}
            >
              前往首页登录
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Login; 